import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/input-cancel-reasons.js';
import form from '../forms/input-cancel-reasons.js';
import * as types from '../types.js';

const inputCancelReasons = function ()
{
	const icr_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(e => notify(e)));
		},
		async queryData(query)
		{
			return await api.call(api.list_input_cancel_reasons, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_input_cancel_reason, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			const _record = { name: String(data.name || '').trim() };
			if (old_data)
				return await api.call(api.update_input_cancel_reason, data.company_id, data.id, _record);
			return await api.call(api.insert_input_cancel_reason, data.company_id, _record);
		},
		async deleteSelected()
		{
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length)
				return notify('Selecione ao menos um registro.', 'Motivos de cancelamento');
			ask(
				`Desativar ${ids.length} motivo(s)? Motivos já usados em Entradas ficam inativos (não são apagados).`,
				'Desativar',
				async (answer) =>
				{
					if (answer !== 'Y') return;
					for (const [company_id, id] of ids)
					{
						const resp = await api.call(api.delete_input_cancel_reason, company_id, id);
						if (resp === undefined) return;
					}
					this.reloadPage();
				}
			);
		},
	});

	router.set('#input-cancel-reason-delete', icr_crud.deleteSelected.bind(icr_crud));

	const fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Id', types: [], placeholder: '', title: 'Identificador' },
		{ index: 3, field: 'name', label: 'Motivo', types: [], placeholder: '', title: 'Motivo' },
		{ index: 4, field: 'is_disabled', label: 'Inativo', types: [types.opt_bool()], placeholder: '', title: 'Inativo' },
	];

	const operations = [
		{ hash: '#input-cancel-reason-delete', label: 'Desativar' },
	];

	icr_crud.run(
		'input_cancel_reasons',
		'Motivos&nbsp;Cancelamento&nbsp;Entrada',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations
	);
};

export default inputCancelReasons;
